<template>
	<div v-show="musicOf()">
		<div @click="play()" id="music" :class="Icon">
			<audio ref="music" :src="musicid"></audio>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			current: String,
		},
		name: "MusicIcon",
		data() {
			return {
				Icon: "bi bi-play-fill",
				name: "",
				musicid: "https://music.163.com/song/media/outer/url?id=492390949.mp3"
			};
		},
		methods: {
			play() {
				if (this.$refs.music.paused) {
					this.$refs.music.play();
					this.Icon = "bi bi-pause-fill";
				} else {
					this.$refs.music.pause();
					this.Icon = "bi bi-play-fill";
				}
			},
			musicOf() {
				this.name = this.$route.name
				if (this.name == "MusicPlayer") {
					return false;
				}
				return true;
			}
		},

		mounted() {
			this.name = this.$route.name
			this.$emit("player", this.$refs.music);
			setInterval(() => {
				if (this.$refs.music.paused) {
					this.Icon = "bi bi-play-fill";
				}
				if (!this.$refs.music.paused) {
					this.Icon = "bi bi-pause-fill";
				}
			}, 1000);
		}
	};
</script>

<style scoped>
	#music {
		position: fixed;
		right: 10px;
		top: 80px;
		z-index: 1;
		width: 40px;
		height: 40px;
		font-size: 40px;
		cursor: pointer;
	}
</style>
